/**
 * Sanitizes value to avoid instances where objects are passed in.
 * @param value - value to be sanitized
 */
export function sanitizeValue(value: unknown): string {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  // To string cast of the value
  return `${value}`;
}
